import React, { ReactNode } from 'react'
import ReactJoyride from 'react-joyride'
import { OnboardingTooltip } from '@domoscio/domoscio-ui'
import { domUtils } from '@domoscio/domoscio-sdk-js'
import I18n from '../../locales/I18n'
import { User } from '../../contexts/parameters'
import { domoscioAccess } from '../../api/domoscio_access'

type Props = {
  children: ReactNode
}

const steps = () => {
  return [
    {
      title: I18n.t('tour.learning_program_index.title_step_1'),
      target: '.step1 .card',
      content: I18n.t('tour.learning_program_index.step_1'),
      disableBeacon: true
    }
  ]
}

const LearningProgramIndex = ({ children }: Props) => {
  const user = React.useContext(User.State)
  const userDispatch = React.useContext(User.Dispatch)

  let runTour = true
  if (user.onboarding?.lxp_hub?.learningProgramIndex) {
    runTour = false
  }

  const handleCallbackJoyRide = (data: any) => {
    const { action, status } = data

    // Send finished tour to server
    if (status === 'finished' || action === 'reset') {
      const newOnboarding = domUtils.updateTour(user.onboarding, 'lxp_hub', {
        learningProgramIndex: true
      })
      if (!user.onboarding?.lxp_hub?.learningProgramIndex) {
        userDispatch({ ...user, onboarding: newOnboarding })
        domoscioAccess.updateUserParameter({ onboarding: newOnboarding })
      } else {
        userDispatch({ ...user, replayTour: { ...user.replayTour, learningProgramIndex: false } })
      }
    }
  }

  return (
    <div>
      <ReactJoyride
        floaterProps={{ disableAnimation: true }}
        tooltipComponent={OnboardingTooltip}
        steps={steps()}
        continuous={true}
        run={user.replayTour.learningProgramIndex || runTour}
        styles={{
          options: {
            zIndex: 10000
          },
          spotlight: {
            borderRadius: 20
          }
        }}
        callback={arg => handleCallbackJoyRide(arg)}
      />
      {children}
    </div>
  )
}

export default LearningProgramIndex
